/**
 * A one-line identity for an arbitrary object, for diagnostics.
 *
 * Kept short and total: this runs on host-page objects whose getters can throw,
 * and a diagnostic must never be the thing that breaks the editor. Lives in
 * `base` because every layer that warns about "some object" needs it — the
 * inspector's recursion guard and the hierarchy's missing-provider warning were
 * otherwise going to grow their own copies.
 */
export function describeObject(object: unknown): string {
    if (object === null) return "null";
    if (object === undefined) return "undefined";
    try {
        const o = object as { type?: unknown; name?: unknown; uuid?: unknown };
        const type = typeof o.type === "string" && o.type
            ? o.type
            : (object as object).constructor?.name ?? typeof object;
        const name = typeof o.name === "string" && o.name.trim().length > 0 ? ` "${o.name}"` : "";
        const uuid = typeof o.uuid === "string" && o.uuid ? ` (${o.uuid})` : "";
        return `${type}${name}${uuid}`.slice(0, 110);
    }
    catch {
        // a throwing getter tells us nothing except that it threw
        return "<undescribable object>";
    }
}
